<app-logo-area [breadcrumbs]="breadCrumbs()"></app-logo-area>
<main>
  <app-headline-section
    [title]="airline()?airline().airline_possessive + ' Previews':''">
  </app-headline-section>


  <app-filter-section [all]="poItems$()" [filtered]="poItemsSortedFiltered$()" [formGroup]="filters">
    <form [formGroup]="filters" class="cl-form">
      <input type="text" style="width: 100%" formControlName="t"
             placeholder="Filter by ID and name" autofocus>
      <p class="valid-feedback">Filter terms are case-insensitive.</p>
    </form>
  </app-filter-section>
  <section class="cl-section cl-section-regular">

    @if (loading) {
      <div>
        <div class="col-12" style="height: 30vh"></div>
        <div style="width: 100%; display: flex;  align-items: center; justify-content: center;">
          <div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div>
        </div>
      </div>
    }
    @if (!loading && poItemsSortedFiltered$(); as poItemsFiltered) {
      <div class="container">
        <div class="row">
          <div class="col-12">
            <table style="table-layout: fixed;" class="cl-table-data">
              <colgroup>
                <col span="1" style="width: 50%">
                <col span="1" style="width: 50%">
                <col span="1" style="width: 180px">
                <col span="1" style="width: 90px;">
              </colgroup>
              <thead>
              <tr>
                <th> Project Name</th>
                <th> Title</th>
                <th> Date</th>
                <th> Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td colspan="4">
                  <a [routerLink]="['/o', organization()?.id, 'previews']">.. (up)</a>
                </td>
              </tr>
                @for (poitem of poItemsFiltered; track poitem) {
                  <tr>
                    <td>{{ poitem.po.po_name }}</td>
                    <td>
                      {{ poitem.po_item_id }}
                    </td>
                    <td>{{ poitem.preview.dash_manifest_last_modified | cldate }}</td>
                    <td><a class="cl-a-btn cl-a-primary"
                           [routerLink]="['/o',this.organization()?.id , 'previews', poitem.po.airline, poitem.po.po_name, poitem.po_item_id, 'preview']">Preview</a>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
  </section>
</main>
